// 分时段 使用key
const hourMapKey = {
  "1-5": "caa1ad8297b754f86bdb07e13c2d6fd3",
  "6-9": "344534191265f81d09084768c6524808",
  "10-12": "9ff824329d0ff40667c98b2bcf00333e",
  "13-14": "7284f074f6b566b4cc6219f1840037eb",
  "15-16": "22997d8558ecb4d33204be1107936a56",
  "17-18": "e2447c0eb57a0125b8705bbd32f2fed1",
  "19-20": "649e0510b48a0866c17a7199605e2ce7",
  "21-24": "9ff824329d0ff40667c98b2bcf00333e",
};
const tempToken = "0e04da8a36740addc847c32697636518"; // 备用
// 生成gis服务的token
export default function generateToken() {
  const hour = new Date().getHours() + 1;
  const result = Object.keys(hourMapKey).filter((item) => {
    const range = item.split("-");
    return hour >= parseInt(range[0]) && hour <= parseInt(range[1]);
  });
  return (result.length && hourMapKey[result[0]]) || tempToken;
}
